export default {"src":"/_next/static/media/social.8c6bc37a.svg","height":24,"width":35};